import { useQuery } from "@apollo/client/react";
import type { ClientStatisticsModel } from "../../../models/ClientModel";
import GET_CLIENT_STATISTICS from "../../queries/client/getClientStatistics";

export const useClientStatistics = (clientIdentifier: string) => {
  const { data, error, loading, refetch } = useQuery<{
    client: ClientStatisticsModel;
  }>(GET_CLIENT_STATISTICS, {
    variables: { clientIdentifier },
    errorPolicy: "all",
  });
  return { clientStatistics: data?.client, error, loading, refetch };
};
